import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7fa81284")

_pushScopeId("data-v-7fa81284")
const _hoisted_1 = {
  key: 0,
  class: "flex items-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return true
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          style: `width: ${_ctx.barWidth}px`,
          class: `w-1 inline-block mr-1 my-2 bar-one bg-loading-${_ctx.variant}`
        }, null, 6),
        _createVNode("div", {
          style: `width: ${_ctx.barWidth}px`,
          class: `w-1 inline-block mr-1 my-2 bar-two bg-loading-${_ctx.variant}`
        }, null, 6),
        _createVNode("div", {
          style: `width: ${_ctx.barWidth}px`,
          class: `w-1 inline-block mr-1 my-2 bar-three bg-loading-${_ctx.variant}`
        }, null, 6)
      ]))
    : _createCommentVNode("", true)
})